export default {
  namespaced: true,
  state: {
    showConfetti: false,
    confettiPlayed: false,
    confettiProps: {
      heading: "",
      subHeading: "",
      timeout: 0
    }
  },
  getters: {},
  mutations: {
    updateShowConfetti(state, payload) {
      state.showConfetti = payload;
      if(payload) {
        state.confettiPlayed = true;
      }
      payload ? 
        document.body.classList.add("body-stop-scroll-mobile") :
        document.body.classList.remove("body-stop-scroll-mobile");
    },
    updateConfettiProps(state, payload) {
      const {
        heading = "",
        subHeading = "",
        timeout = 1000
      } = payload;
      state.confettiProps = {
        heading,
        subHeading,
        timeout
      };
    }
  },
  actions: {}
}